module.exports = __webpack_public_path__ + "static/blue_grren2-a4433c9a65ca570fc669b122571bc874.png";